import { render, staticRenderFns } from "./ComentarioPrestamos.vue?vue&type=template&id=a65c79dc&scoped=true&"
import script from "./ComentarioPrestamos.vue?vue&type=script&lang=js&"
export * from "./ComentarioPrestamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c79dc",
  null
  
)

export default component.exports